import { useMutation, UseMutationResult, useQueryClient } from '@tanstack/react-query';
import { patchAudioSchemaFile } from '../../services/AudioSchemaService';
import { AudioSchema, AudioSchemaAudioPatchRequest } from '../../types/AudioSchemas';

type Result = UseMutationResult<AudioSchema, Error, AudioSchemaAudioPatchRequest>;

function usePatchAudioSchemaFile(successCb: () => void, failureCb: (error: string) => void): Result {
  const queryClient = useQueryClient();

  return useMutation(patchAudioSchemaFile, {
    onSuccess: () => {
      successCb();
      queryClient.invalidateQueries({ queryKey: ['audio-schemas'] });
    },
    onError: (error: Error) => {
      failureCb(error.message);
    },
  });
}

export default usePatchAudioSchemaFile;
